import { render, staticRenderFns } from "./DarkPostFilter.vue?vue&type=template&id=6caae262&scoped=true&"
import script from "./DarkPostFilter.vue?vue&type=script&lang=js&"
export * from "./DarkPostFilter.vue?vue&type=script&lang=js&"
import style0 from "./DarkPostFilter.vue?vue&type=style&index=0&id=6caae262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caae262",
  null
  
)

export default component.exports